export const SecurityMutationKeys = {
  all: ["mutation", "security"] as const,
  login: () => [...SecurityMutationKeys.all, "login"] as const,
  logout: () => [...SecurityMutationKeys.all, "logout"] as const,
};
